// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 67) return "css/academics-dbb10163.css";
	if (chunkId === 936) return "css/fused-d6349b42.css";
	if (chunkId === 740) return "css/print-50609a88.css";
	if (chunkId === 964) return "css/style_guide-00840f91.css";
	if (chunkId === 165) return "css/zeit_jobs-2eb515d1.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"125":"1046c521","189":"640191d9","338":"8d2be4a0","428":"d857e209","562":"74262273","608":"640191d9"}[chunkId] + ".css";
};